import initClosest from './closest';

export default function() {
    initClosest();
}


// WEBPACK FOOTER //
// ./uPortal/Content/js/Polyfill/index.js